<template>
  <div class="foot b_white">
    <div class="w1200 clearfix" id="hideAD">
      <a href="javascript:;"><img src="./images/1200-120.jpg?v=1619654438100" /></a>
    </div>
    <div class="w1200 t_center">
      <ul class="clearfix text-center">
        <li><span class="f20 yahei gray_3 icon0">名牌汇聚</span></li>
        <li><span class="f20 yahei gray_3 icon1">优质优价</span></li>
        <li><span class="f20 yahei gray_3 icon2">特级服务</span></li>
        <li><span class="f20 yahei gray_3 icon3">正品保障</span></li>
      </ul>
      <div class="f_line"></div>
      <div class="box35"></div>
      <div class="f_codelie clear yahei pad10_l">
        <div class="t_left pull-left">
          <h2 class="normal f18">进货指南</h2>
          <ul>
            <li>
              <a target="_blank" :href="`${origin.VUE_APP_APP}/goods/tofootindex/memberregistGuide.do`" class="f14 gray_3">用户注册</a>
            </li>
            <li>
              <a target="_blank" :href="`${origin.VUE_APP_APP}/goods/tofootindex/shoppingprocessGuide.do`" class="f14 gray_3">购物流程</a>
            </li>
            <li>
              <a target="_blank" :href="`${origin.VUE_APP_APP}/goods/tofootindex/commonproblemGuide.do`" class="f14 gray_3">常见问题</a>
            </li>
          </ul>
        </div>
        <div class="t_left pull-left">
          <h2 class="normal f18">支付方式</h2>
          <ul>
            <li>
              <a target="_blank" :href="`${origin.VUE_APP_APP}/goods/tofootindex/payment1Type.do`" class="f14 gray_3">在线支付</a>
            </li>
            <li>
              <a target="_blank" :href="`${origin.VUE_APP_APP}/goods/tofootindex/payment2Type.do`" class="f14 gray_3">线下结算</a>
            </li>
          </ul>
        </div>
        <div class="t_left pull-left">
          <h2 class="normal f18">配送服务</h2>
          <ul>
            <li>
              <a target="_blank" :href="`${origin.VUE_APP_APP}/goods/tofootindex/distribution1Service.do`" class="f14 gray_3">配送范围</a>
            </li>
            <li>
              <a target="_blank" :href="`${origin.VUE_APP_APP}/goods/tofootindex/distribution2Service.do`" class="f14 gray_3">自提服务</a>
            </li>
          </ul>
        </div>
        <div class="t_left pull-left">
          <h2 class="normal f18">售后保障</h2>
          <ul>
            <li>
              <a target="_blank" :href="`${origin.VUE_APP_APP}/goods/tofootindex/returnPolicy.do`" class="f14 gray_3">退换政策</a>
            </li>
          </ul>
        </div>
        <div class="t_left pull-left">
          <h2 class="normal f18">商家合作</h2>
          <ul>
            <li>
              <a target="_blank" :href="`${origin.VUE_APP_APP}/goods/tofootindex/processEnter.do`" class="f14 gray_3">商家入驻</a>
            </li>
            <li>
              <a target="_blank" :href="`${origin.VUE_APP_APP}/goods/tofootindex/basicRules.do`" class="f14 st gray_3">平台规则</a>
            </li>
            <li>
              <a target="_blank" :href="`${origin.VUE_APP_APP}/operationCenter/toOperationCenter.do`" class="f14 st gray_3">运营中心申请</a>
            </li>
          </ul>
        </div>
        <div class="pull-left pad70_l">
          <div class="f_codeimg1 pull-right pad70_l">
            <img src="./images/codeimg1.jpg?v=1619654438100" />
            <p class="f14 st gray_3 text-center">农信商城微信</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./style.scss";
</style>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      origin: process.env,
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  mounted() {},
  methods: {},
};
</script>
